import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    enableTimeFilter: boolean;
  }>()
  .create(({ theme, enableTimeFilter }) => ({
    searchbar: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1)
    },
    searchbarContainer: {
      width: '',
      [theme.breakpoints.down('lg')]: {
        width: '100%'
      }
    },
    searchbarInputContainer: {
      [theme.breakpoints.down('xxl')]: {
        width: '30%'
      },
      [theme.breakpoints.down('xl')]: {
        width: '45%'
      },
      [theme.breakpoints.down('lg')]: {
        width: '70%'
      },
      display: 'flex',
      minWidth: '22vw'
    },
    searchbarInput: {
      width: '50%',
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      borderRadius: !enableTimeFilter
        ? `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`
        : 0,
      borderWidth: '1px 0 1px 1px',
      borderStyle: 'solid',
      borderColor: theme.vars.palette.border.main,
      padding: theme.spacing(0, 0.5),
      gap: theme.spacing(0.5),
      overflow: 'hidden',
      '& input': {
        border: 0,
        outline: 'none',
        flex: 1,
        background: 'transparent',
        width: '100%',
        color: theme.vars.palette.text.primary,
        position: 'absolute',
        left: 0,
        right: 0,
        fontSize: '0.875rem'
      }
    },
    textInputWrapper: {
      flex: 1,
      minWidth: '2rem',
      position: 'relative',
      height: '1.25rem',
      display: 'flex',
      alignItems: 'center'
    },
    searchbarSearchBtn: {
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
      backgroundColor: theme.vars.palette.transparent.a10,
      padding: theme.spacing(0.5, 1)
    },
    searchbarFilterChip: {
      maxWidth: '15rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }));

export default useStyles;
